import { useResetRecoilState } from 'recoil'
import {
    currentRegisterStepState,
    registerStepState,
    phoneNumberState,
    registerRefCodeVerifyState,
    currentForgetPasswordStepState,
    forgetPasswordStepState,
    forgetPasswordPhoneState,
    otpRefCodeState,
    signinOtpRefCodeState,
    signinOtpPhoneNumberState,
    signinOtpOrganizationIdState,
} from '../../modules/auth/stores/atom'

export const useClearLoginState = () => {
    const resetCurrentRegisterStep = useResetRecoilState(currentRegisterStepState)
    const resetRegisterStep = useResetRecoilState(registerStepState)
    const resetPhoneNumber = useResetRecoilState(phoneNumberState)
    const resetRegisterRefCodeVerify = useResetRecoilState(registerRefCodeVerifyState)
    const resetCurrentForgetPasswordStep = useResetRecoilState(currentForgetPasswordStepState)
    const resetForgetPasswordStep = useResetRecoilState(forgetPasswordStepState)
    const resetForgetPasswordPhone = useResetRecoilState(forgetPasswordPhoneState)
    const resetOtpRefCode = useResetRecoilState(otpRefCodeState)
    const resetSigninOtpRefCode = useResetRecoilState(signinOtpRefCodeState)
    const resetSigninOtpPhoneNumber = useResetRecoilState(signinOtpPhoneNumberState)
    const resetSigninOtpOrganizationId = useResetRecoilState(signinOtpOrganizationIdState)

    const clearLoginState = () => {
        resetCurrentRegisterStep()
        resetRegisterStep()
        resetPhoneNumber()
        resetRegisterRefCodeVerify()
        resetCurrentForgetPasswordStep()
        resetForgetPasswordStep()
        resetForgetPasswordPhone()
        resetOtpRefCode()
        resetSigninOtpRefCode()
        resetSigninOtpPhoneNumber()
        resetSigninOtpOrganizationId()
    }

    return { clearLoginState }
}
